import {
	enableWebSdk,
	getNotificationPromptValueInLocalStorage,
	setNotificationPromptValueInLocalStorage,
} from "../../functions/index";

const MAX_REPEAT_ASKS =
	airship_web_sdk_settings?.notificationsSoftAsk?.maxRepeatAsks || 3;
const DAYS_BEFORE_NEXT_PROMPT =
	airship_web_sdk_settings?.notificationsSoftAsk?.daysBetweenAsks || 14;

(() => {
	/**
	 * Soft ask is disabled in WordPress admin
	 */
	if (!airship_web_sdk_settings?.notificationsSoftAsk?.isActive) {
		return;
	}

	/**
	 * Notification API is unavailable
	 */
	if ("undefined" === typeof Notification) {
		return;
	}

	/**
	 * Enable UA web sdk with push notifications enabled
	 * dependent on user permissions
	 */
	enableWebSdk({
		pushNotifications: Notification.permission === "granted",
	});

	/**
	 * Hop out early if permissions have either been
	 * granted or denied.
	 */
	if (
		Notification.permission === "denied" ||
		Notification.permission === "granted"
	) {
		return;
	}

	/**
	 * Check local storage to determine if soft ask should
	 * be displayed.
	 */
	if (window.localStorage.getItem("airship-notification-prompt") === null) {
		setNotificationPromptValueInLocalStorage(); // Passing in no value sets the defaults
	}

	const { hasAccepted, lastTimeAsked, views } =
		getNotificationPromptValueInLocalStorage();

	if (hasAccepted && Notification.permission !== "granted") {
		setNotificationPromptValueInLocalStorage({
			hasAccepted: false,
		});
	}

	const delay = 1000 * 60 * 60 * 24 * DAYS_BEFORE_NEXT_PROMPT;
	const nextTimeToAsk = lastTimeAsked + delay;

	/**
	 * If it hasn't been long enough or if the soft ask has been
	 * presented too many times, then drop out early.
	 */
	if (views >= MAX_REPEAT_ASKS && Date.now() < nextTimeToAsk) {
		return;
	}

	/**
	 * Increment the views and update the last time asked.
	 */
	setNotificationPromptValueInLocalStorage({
		hasAccepted: false,
		lastTimeAsked: Date.now(),
		views: views + 1,
	});

	/**
	 * Add event listeners for the soft ask banner.
	 */
	window.addEventListener(
		"airship-notifications-soft-ask-opt-in",
		({ detail }) => {
			setNotificationPromptValueInLocalStorage({
				hasAccepted: true,
			});
			enableWebSdk({
				pushNotifications: true,
			});
		}
	);

	window.addEventListener(
		"airship-notifications-soft-ask-dismiss",
		({ detail }) => {
			//
		}
	);

	/**
	 * Dispatch event for the soft ask banner.
	 */
	window.dispatchEvent(
		new CustomEvent("airship-notifications-soft-ask", {
			bubbles: true,
			detail: {},
		})
	);

	/**
	 * Present the soft ask banner.
	 */
	const $banner = document.createElement("airship-notification-banner");

	$banner.setAttribute(
		"opt-in-label",
		airship_web_sdk_settings?.notificationsSoftAsk?.optInLabel
	);
	$banner.setAttribute(
		"opt-out-label",
		airship_web_sdk_settings?.notificationsSoftAsk?.optOutLabel
	);
	$banner.setAttribute(
		"text",
		airship_web_sdk_settings?.notificationsSoftAsk?.text
	);

	document.body.appendChild($banner);
})();
